<div class="step-panel step-panel-compact step-panel-equipo">
  <h3>Equipo de trabajo</h3>
  <p class="step-intro">Prepara la postulacion con las personas clave y el patrocinio requerido para el concurso.</p>

  <div class="section-block invitation-section" *ngIf="puedeInvitar">
    <h4>Invitar participante</h4>

    <div class="form-grid invitation-grid">
      <label class="field">
        <span>Rol a invitar</span>
        <select [(ngModel)]="rolSeleccionado" [disabled]="soloLectura">
          <option value="">Seleccione</option>
          <option value="recomendador">Recomendador</option>
          <option value="colaborador">Integrante del equipo</option>
          <option value="patrocinador">Patrocinador</option>
        </select>
      </label>

      <div class="field field-actions">
        <span>Accion</span>
        <button type="button" class="invite-button" (click)="abrirFormularioInvitacion()" [disabled]="!puedeAbrirFormularioInvitacion">
          Agregar participante
        </button>
      </div>
    </div>

    <div class="placeholder-box invitation-status" *ngIf="institucionesDisponibles.length === 0">
      Primero registra al menos una institucion para asociar cada integrante del equipo.
    </div>
  </div>

  <div class="placeholder-box invitation-status" *ngIf="mensajeInvitacion">
    <strong>Estado:</strong> {{ mensajeInvitacion }}
  </div>

  <div class="section-block invitation-form-panel" *ngIf="formularioInvitacionVisible">
    <div class="records-head invitation-form-head">
      <h4>{{ tituloInvitacion() }}</h4>
      <p>Completa los datos del invitado para enviar la solicitud y registrar la accion.</p>
    </div>

    <div class="form-grid invitation-form-grid">
      <label class="field">
        <span>Nombres</span>
        <input type="text" [(ngModel)]="invitado.nombres" [disabled]="enviando" />
      </label>

      <label class="field">
        <span>Apellidos</span>
        <input type="text" [(ngModel)]="invitado.apellidos" [disabled]="enviando" />
      </label>

      <label class="field">
        <span>Rut</span>
        <input type="text" [(ngModel)]="invitado.rut" [disabled]="enviando" />
      </label>

      <label class="field">
        <span>Email</span>
        <input type="email" [(ngModel)]="invitado.email" [disabled]="enviando" />
      </label>

      <label class="field field-full">
        <span>Institucion asociada</span>
        <select [(ngModel)]="invitado.institucionAsociada" [disabled]="enviando">
          <option value="">Seleccione</option>
          <option *ngFor="let institucion of institucionesDisponibles" [value]="institucion">{{ institucion }}</option>
        </select>
      </label>
    </div>

    <div class="inline-form-actions">
      <button type="button" class="btn-secondary" (click)="cerrarPanelInvitacion()" [disabled]="enviando">Cancelar</button>
      <button type="button" class="btn-primary" (click)="enviarInvitacion()" [disabled]="enviando || !invitado.nombres.trim() || !invitado.apellidos.trim() || !invitado.rut.trim() || !invitado.email.trim() || !invitado.institucionAsociada.trim()">
        {{ enviando ? 'Enviando...' : 'Enviar' }}
      </button>
    </div>
  </div>

  <div class="records-box section-block">
    <div class="records-head">
      <h4>Registro de invitaciones</h4>
      <p>Quedan visibles en esta misma vista para seguimiento del equipo y del patrocinio.</p>
    </div>

    <div class="records-list" *ngIf="registrosParticipacion.length > 0; else sinRegistrosTpl">
      <article class="record-card" *ngFor="let registro of registrosParticipacion">
        <div class="record-top">
          <strong>{{ etiquetaRol(registro.rol) }}</strong>
          <span class="status-pill" [ngClass]="registro.estado === 'aceptado' || registro.estado === 'confirmado' ? 'status-ok' : 'status-pending'">
            {{ etiquetaEstado(registro.estado) }}
          </span>
        </div>

        <div class="record-grid">
          <div><span>Nombre:</span> {{ (registro.nombres + ' ' + registro.apellidos).trim() || '-' }}</div>
          <div><span>Email:</span> {{ registro.email || '-' }}</div>
          <div><span>Institucion:</span> {{ registro.institucionAsociada || '-' }}</div>
          <div><span>Rut:</span> {{ registro.rut || '-' }}</div>
          <div><span>Fecha solicitud:</span> {{ registro.fechaSolicitud ? (registro.fechaSolicitud | date:'dd/MM/yyyy HH:mm') : '-' }}</div>
        </div>
      </article>
    </div>

    <ng-template #sinRegistrosTpl>
      <div class="placeholder-box records-empty">
        Aun no se registran invitaciones o solicitudes para el equipo de trabajo.
      </div>
    </ng-template>
  </div>
</div>
